import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class Utilities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      utilities: this.props.utilities,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {this.state.utilities.map(function (utility, index) {
              return (
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-12 p-0">
                      <Accordion.Item eventKey={index}>
                        <Accordion.Header>
                          {utility.utility.utilityType}
                        </Accordion.Header>
                        <Accordion.Body>
                          <div className="container-fluid">
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Utility Type{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {utility.utility.utilityType}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Utility UOM{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {utility.utility.utilityUom}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Utility Invoice Period{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {utility.utility.invoicePeriod}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Utility Due Date{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {utility.utility.dueDate}
                                      {`-`}
                                      {utility.utility.dueType}
                                      {`-`}
                                      {utility.utility.dueFrequency}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Applicable From{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {utility.utility.applicableFrom}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-5 col-form-label">
                                      Applicable From Date{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <label className="col-sm-7 col-form-label">
                                      {leaseDateFormat(
                                        utility.utility.applicableFromDate
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {utility.utility.utilityType == "Other" && (
                              <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-5 col-form-label">
                                              Sub Category Type <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {utility.utility.subCategoryTypes}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                              )}
                            {utility.utility.rates !== undefined &&
                              utility.utility.rates.map(function (name, index) {
                                return (
                                  <div className="row rateRow">
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-5 col-form-label">
                                            From{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(name.from)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-5 col-form-label">
                                            To <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(name.to)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-5 col-form-label">
                                            Rate{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {name.rate}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }, this)}
                          </div>
                        </Accordion.Body>
                      </Accordion.Item>
                    </div>
                  </div>
                </div>
              );
            }, this)}
          </Accordion>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Notes
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.utilitiesNotes}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Utilities);
